// match height
function matchHeight(elements) {
    const elementArray = Array.from(elements);
    if (elementArray.length === 0) return;

    let rows = [];

    // Reset inline height
    elementArray.forEach(el => el.style.height = '');

    // Group by offsetTop (baris)
    elementArray.forEach(el => {
        const elTop = el.offsetTop;
        let row = rows.find(r => r.top === elTop);

        if (!row) {
            row = { top: elTop, elements: [] };
            rows.push(row);
        }

        row.elements.push(el);
    });

    // Hitung tinggi maksimum global (untuk jaga-jaga baris yang tidak penuh)
    let globalMaxHeight = 0;
    elementArray.forEach(el => {
        const h = el.offsetHeight;
        if (h > globalMaxHeight) globalMaxHeight = h;
    });

    // Atur tinggi tiap row
    rows.forEach(row => {
        let maxHeight = 0;

        row.elements.forEach(el => {
            const h = el.offsetHeight;
            if (h > maxHeight) maxHeight = h;
        });

        // Kalau cuma 1 elemen di row, pakai global max height agar seragam
        const heightToSet = row.elements.length === 1 ? globalMaxHeight : maxHeight;

        row.elements.forEach(el => {
            el.style.height = `${heightToSet}px`;
        });
    });
}

function matchHeightPerRow(elements) {
    const elementArray = Array.from(elements);
    if (elementArray.length === 0) return;
  
    let rows = new Map();
  
    // Reset inline height to calculate natural heights
    elementArray.forEach(el => el.style.height = '');
  
    // Group elements by their top offset (row position)
    elementArray.forEach(el => {
        const elTop = el.getBoundingClientRect().top; // Use precise positioning
        
        if (!rows.has(elTop)) {
            rows.set(elTop, []);
        }
        rows.get(elTop).push(el);
    });
  
    // Apply the max height only within each row
    rows.forEach(rowElements => {
        let maxHeight = Math.max(...rowElements.map(el => el.offsetHeight));
        rowElements.forEach(el => el.style.height = `${maxHeight}px`);
    });
}

export {matchHeight};
export {matchHeightPerRow};
